var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowWhitRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.7 31.3",
    style: {
      enableBackground: "new 0 0 17.7 31.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,31.3c-0.4,0-0.9-0.1-1.2-0.4L3.3,22.1C1.2,20.5,0,18.3,0,15.9c0-2.4,1.1-4.6,3.2-6.2l11.9-9.3 c0.9-0.7,2.1-0.5,2.8,0.3c0.7,0.9,0.5,2.1-0.3,2.8L5.7,12.8c-1.1,0.9-1.7,2-1.7,3.1C4,17,4.6,18.1,5.7,19l11.1,8.7 c0.9,0.7,1,1.9,0.3,2.8C16.8,31,16.2,31.3,15.6,31.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhitRight);
export default __webpack_public_path__ + "static/media/arrow_Whit-right.05d611419665af92a2ed8e96b0a9fd68.svg";
export { ForwardRef as ReactComponent };